(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // click-directive to show info about a user 
    module.directive('userShowInfo', ['UserService', 'SharedAgendaService', function (UserService, SharedAgendaService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                id: '@' // user id
            }
        };
        return directive;

        function link(scope, element) {

            // click listener
            element.on('click', function () {
                show();
            });

            // show info
            function show() {
                UserService.show(scope.id, SharedAgendaService.currentUser().id, SharedAgendaService.data.currentAgenda.id);
            } // show           

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });

        }
    }]);

})();